<script>
	var page = require('page');
	var utilities = require('utilities');
	var Q = require('q');
	var _ = require('underscore');
	var Vue = require('vue');
	var metadataUtils = require('metadata-utils');
	var stringUtilities = require('utilities/stringUtilities');
	var productService = require('services/productService');
	var crudService = require('services/crudService');
	var urlUtilities = require('utilities/urlUtilities');
	var Serializer = require('async/Serializer');
	var model = require('model/model');
	var config = require('core/config');
	var PDF = require('pdf/PDF');
	var hashStore = require('model/stores/hashStore');
	const analyticsUtilities = require('utilities/analyticsUtilities');
	const whiteboardViewMixin = require('mixins/whiteboard-view');
	const { updateMilestone, MILESTONES, updatePPAMilestone } = require('utilities/journeyUtilities');
	const pubsub = require('events/pubsub');
	const ReadWorksProduct = require('types/ReadWorksProduct');
	const { getBookStudyCategoryText } = require('utilities/articleUtilities');
	const logger = require('utilities/logger');
	const { ACTIONS } = require('utilities/assignmentUtilities');

	const fireEvent = analyticsUtilities.fireEvent;
	const PRINT = analyticsUtilities.events.PRINT;
	const WHITEBOARD_TOOL_CLICK = analyticsUtilities.events.WHITEBOARD_TOOL_CLICK;
	const PREVIEW_PRODUCT = analyticsUtilities.events.PREVIEW_PRODUCT;
	const OPEN_ASSIGN_MODAL = analyticsUtilities.events.OPEN_ASSIGN_MODAL;
	const OPEN_PRINT_MODAL = analyticsUtilities.events.OPEN_PRINT_MODAL;
	const PRODUCT_PREVIEW_COPY = analyticsUtilities.events.PRODUCT_PREVIEW_COPY;
	const ADD_TO_BINDER = analyticsUtilities.events.ADD_TO_BINDER;
	const REMOVE_FROM_BINDER = analyticsUtilities.events.REMOVE_FROM_BINDER;

	const mediaUrl = config.resources.media.cdn || config.resources.media.origin;

	var PDF_OPTIONS = {
		widowThreshold: 0.2,
		noPageBreak: ['.question-set-questions', '.vocab-entry', 'figure']
	};

	function generatePDFForSection(target, options) {
		options = options || {};

		_.assign(options, PDF_OPTIONS);

		if (options.header) {
			options.header =
				'<img style="width:110px;height:17px" src="' +
				(config.resources.assets.cdn || config.resources.assets.origin) +
				'/assets/dist/images/rw-bw.jpeg"><span class="vertically-centered" style="top:95%;right:0;font-size:0.75rem">' +
				options.header +
				'</span>';
		}

		var pdf = new PDF(target, options);

		return pdf.generate().then(function (result) {
			return result.pdf;
		});
	}

	module.exports = {
		mixins: [whiteboardViewMixin],
		props: ['on-ready', 'route-context'],
		modelData: ['userContext', 'whiteboardView', 'articleTab', 'whiteboardHighlightDismiss', 'splitTab', 'articleEntryPoint', 'gcAddon'],
		components: {
			passage: require('./article-tabs/content.vue').default,
			ebook: require('./article-tabs/ebook.vue').default,
			'video-tab': require('./article-tabs/video.vue').default,
			'vocab-activities': require('./article-tabs/vocab-activities.vue').default,
			questionsets: require('./article-tabs/question-sets.vue').default,
			stepreads: require('./article-tabs/stepreads.vue').default,
			'book-of-knowledge': require('./article-tabs/book-of-knowledge.vue').default,
			'word-detective-preview': require('./article-tabs/word-detective-preview.vue').default,
			'meaning-mapper-preview': require('./article-tabs/meaning-mapper-preview.vue').default,
			decodables: require('./article-tabs/decodables.vue').default,
			'add-to-my-list-button': require('components/add-to-my-list-button.vue').default,
			'load-mask': require('components/load-mask.vue').default,
			printvocabulary: require('components/printvocabulary.vue').default,
			'tab-panel': require('components/tab-panel.vue').default,
			'tab-container': require('components/tab-container.vue').default,
			'info-icon': require('components/svg/info-icon.vue').default,
			'assignment-wizard': require('components/assignment-wizard.vue').default,
			'classroom-addon-lock-tooltip': require('components/classroom-addon-lock-tooltip.vue').default
		},
		created() {
			var self = this;

			this.$watch(
				'routeContext.params.article',
				function (articleId) {
					self.printOptions = [];

					var promises = [];

					self.wordId = null;
					self.article = null;
					model.set('activeProduct', null);

					self.productLoading = true;

					promises.push(
						productService
							.get(articleId)
							.then(function (article) {
								if (article) {
									var articleTitleURLFragment = urlUtilities.stringToURLFragment(article.title);

									if (self.routeContext.params.title !== articleTitleURLFragment) {
										page.replace(urlUtilities.getProductURL(article));
									}

									self.article = article;
									self.initFromSearchResults();

									if (self.userContext) {
										updateMilestone(MILESTONES.productPreviewByType, article.productType);
									}

									let passageLabel = 'Passage';
									const isArticle = article.productType === 'A';
									const isAAD = article.productType === 'AAD';
									const isPairedText = article.productType === 'P';
									const isTextSet = article.productType === 'TS';
									const hasVocabActivity = self.hasVocabActivity;
									const hasTextSetVocab = isTextSet && hasVocabActivity;
									const questionSets = self.orderedQuestionSetsMinusVocab;

									if (isArticle) {
										self.printOptions = ['content'];
									} else if (isPairedText) {
										self.printOptions = Object.values(article.articles).map(a => `content_${a.uuid}`);
									} else if (isTextSet) {
										self.printTextSets.selectedPassages = article.articleList.map(a => a.uuid);
									}

									if (self.orderedQuestionSetsMinusVocab.length > 0 && !isTextSet) {
										self.printOptions.push(`questionsets_${self.orderedQuestionSetsMinusVocab[0].qsid}`);
									}

									if (hasVocabActivity) {
										self.printOptions.push('printvocabulary', 'vocab-activities');
									}

									if (isPairedText && article.hasVideo) {
										passageLabel += ' & Video';
									} else if (isPairedText || isAAD) {
										passageLabel += 's';
									}

									let tabs = [
										{
											component: 'content',
											label: passageLabel,
											authRequired: false,
											split: 'content',
											renderCondition: true
										},
										{
											component: 'book-of-knowledge',
											label: 'Book of Knowledge',
											authRequired: true,
											split: 'activity',
											renderCondition: isAAD
										},
										{
											component: 'word-detective-preview',
											label: 'Word Detective',
											authRequired: true,
											split: 'activity',
											renderCondition: isAAD && article.word_detective
										},
										{
											component: 'meaning-mapper-preview',
											label: 'Meaning Mapper',
											authRequired: true,
											split: 'activity',
											renderCondition: isAAD && article.meaning_mapper
										},
										{
											component: 'decodables',
											label: 'Decodables',
											authRequired: true,
											split: 'content',
											renderCondition: !self.gcAddon && isAAD && article.dteGroups
										},
										{
											component: 'stepreads',
											label: 'StepReads™',
											authRequired: false,
											split: 'content',
											renderCondition: article.sr
										},
										{
											component: 'video-tab',
											label: 'Video',
											authRequired: true,
											split: 'content',
											renderCondition: article.subType !== 103 && article.video
										},
										{
											component: 'vocab-activities',
											label: hasTextSetVocab ? 'Vocabulary Activities' : 'Vocabulary Activity',
											authRequired: true,
											split: 'activity',
											renderCondition: (article.vocab && article.vocab.activity) || hasTextSetVocab
										},
										{
											component: 'questionsets',
											label: questionSets.length > 1 ? 'Question Sets' : 'Question Set',
											authRequired: true,
											split: 'activity',
											renderCondition: questionSets && questionSets.length > 0
										},
										{
											component: 'ebook',
											label: 'eBook',
											authRequired: true,
											renderCondition: article.ebook
										}
									];

									self.tabs = tabs.filter(tab => !!tab.renderCondition);

									model.set('activeProduct', article);

									fireEvent(PREVIEW_PRODUCT, {
										pid: article.id || article.uuid
									});
								}
							})
							.catch(err => {
								if (err && err.status === 403) {
									self.productNotFound = true;
								}
							})
							.finally(() => {
								self.tabAuthenticationCheck();
							})
					);

					Q.all(promises)
						.then(function () {
							Vue.nextTick(function () {
								self.$emit('data-ready');
							});
						})
						.finally(() => (self.productLoading = false));
				},
				{
					immediate: true
				}
			);

			pubsub.subscribe('article-selected', function (selectedArticle) {
				self.selectedArticle = selectedArticle;
			});

			self.unsubAssignmentEnd = pubsub.subscribe(ACTIONS.ASSIGNMENT_ACTION_END, self.updatePPAMilestone);

			var searchResultQueryString = model.get('searchResultQueryString');
			self.searchResults = searchResultQueryString;
			this.buildSearchResultsMap(searchResultQueryString);

			if (this.article) {
				this.initFromSearchResults();
			}

			model.set('searchResultQueryString', null);

			var promoLink = model.get('promoLink');
			this.promoLink = promoLink;
			model.set('promoLink', null);

			var scopeSequenceLink = model.get('scopeSequenceLink');
			this.scopeSequenceLink = scopeSequenceLink;
			model.set('scopeSequenceLink', null);

			// send ready notice to parent
			if (typeof this.onReady === 'function') {
				this.onReady();
			}

			this.getMyList();
		},
		beforeDestroy() {
			this.unsubAssignmentEnd?.();
			model.set('activeProduct', null);
			model.set('articleEntryPoint', null);
		},
		watch: {
			userContext: function (value) {
				if (value) {
					this.getMyList();
				}
			},
			articleTab: function (articleTab) {
				this.tabAuthenticationCheck();
				this.maybeOpenHighlightingModal();
			},
			usePDFExtendedFont(useExtended) {
				if (useExtended) {
					PDF.initExtendedFonts();
				}
			},
			tabs(tabs) {
				const mappedTabs = tabs.map(t =>
					_.assign({}, t, {
						id: t.component,
						text: t.label
					})
				);

				this.contentTabs = mappedTabs.filter(t => t.split === 'content');
				this.splitTabs = mappedTabs.filter(t => t.split === 'activity');
			},
			whiteboardView(projected) {
				if (projected) {
					this.updatePPAMilestone();
				}
			}
		},
		computed: {
			/**
			 * we were ordering by tab components, but we need "printvocabulary" to
			 * be in order even though it doesn't have a tab. So we put vocab right
			 * after "content" or at the beginning if content is not there.
			 */
			printOrdering() {
				const tabs = this.tabs || [];
				var order = tabs.map(t => t.component);
				var vocabIdx = order.indexOf('content') + 1;
				order.splice(vocabIdx, 0, 'printvocabulary');
				return order;
			},
			title: function () {
				let article = this.article;
				let t = null;

				if (article) {
					t = article.pageTitle || `${article.title} | ReadWorks`;
				}

				return t;
			},
			pageDescription: function () {
				let article = this.article;
				return article && article.pageDesc;
			},
			loading() {
				let productLoading = this.productLoading;
				let article = this.article;

				return productLoading || !article || !article.id;
			},
			challengeArticles() {
				let articles = null;
				if (this.article.supplemental_texts && this.article.supplemental_texts.challenge) {
					articles = Object.keys(this.article.supplemental_texts.challenge)
						.sort()
						.map(key => {
							return this.article.supplemental_texts.challenge[key];
						});
				}
				return articles;
			},
			supportArticles() {
				let articles = null;
				if (this.article.supplemental_texts && this.article.supplemental_texts.support) {
					articles = Object.keys(this.article.supplemental_texts.support)
						.sort()
						.map(key => {
							return this.article.supplemental_texts.support[key];
						});
				}
				return articles;
			},
			orderedQuestionSetsMinusVocab() {
				const article = this.article;
				const articleQuestionSets = a => (Array.isArray(a.questionSetsOrdered) && a.questionSetsOrdered.filter(qs => !qs.isVocab)) || [];
				const isTextSet = article.productType === 'TS';

				if (isTextSet) {
					return article.articleList.reduce((acc, a) => {
						const qs = articleQuestionSets(a);

						return [...acc, ...qs];
					}, []);
				}

				return articleQuestionSets(article);
			},
			hasExpressQuestionSets() {
				return this.orderedQuestionSetsMinusVocab.some(qset => qset.abridged_question_ids && qset.abridged_question_ids.length > 0);
			},
			hasVocabActivity() {
				const article = this.article;
				const isTextSet = article.productType === 'TS';

				if (isTextSet) {
					return article.articleList.some(a => a.vocab && a.vocab.activity);
				}

				return !!(article.vocab && article.vocab.activity);
			},
			articleTabComponent() {
				const articleTab = this.articleTab;

				const tabDict = {
					content: 'passage',
					video: 'video-tab'
				};

				return tabDict[articleTab] || articleTab;
			},
			usePDFExtendedFont() {
				const { hasExtendedCharacters } = this.article || {};
				return !!hasExtendedCharacters;
			},
			aadTOCArticles() {
				const article = this.article;

				if (!article || !article.articleList) {
					return [];
				}

				let articles = [...article.articleList];

				if (this.support && this.supportArticles) {
					articles = articles.concat(this.supportArticles);
				}

				if (this.challenge && this.challengeArticles) {
					articles = articles.concat(this.challengeArticles);
				}

				if (this.printDecodables.all && article.dteGroups) {
					const decodableArticles = article.dteGroups.reduce((acc, group) => acc.concat(Object.values(group.articles)), []);

					articles = articles.concat(decodableArticles);
				}

				return articles;
			},
			printLogoSrc() {
				return urlUtilities.assetUrl('/assets/dist/images/rw-bw.jpeg');
			},
			assignmentWizardOptions() {
				// assignment wizard needs instance methods
				// alternatively, send uuids through productIds prop and allow wizard to fetch each child
				const products = this.article.articleList.map(article => new ReadWorksProduct(article));
				const hasVocabActivity = this.hasVocabActivity;
				const hasQuestionSets = this.orderedQuestionSetsMinusVocab.length > 0;

				return {
					products,
					bok: false, //overwrite default for AAD
					vocabulary: hasVocabActivity,
					questionSets: hasQuestionSets,
					fullOrExpress: 'f'
				};
			}
		},

		data: function () {
			return {
				printMode: 'packet',
				challenge: false,
				support: false,
				article: null,
				isPrinting: false,
				metaData: {},
				tabs: [],
				wordId: null,
				binder: null,
				printOptions: null,
				lines: 'false',
				selectedArticle: null,
				productNotFound: null,
				mediaUrl: mediaUrl,
				productLoading: true,
				searchResults: null,
				searchResultsMap: null,
				whiteboardDismissProduct: false,
				scopeSequenceLink: null,
				fontSizeClass: '',
				paragraphsNumbered: false,
				splitScreen: false,
				fullOrExpress: {},
				userFullOrExpress: {},
				whiteboardViewData: {
					tabKey: 'articleTab',
					highlightingModalSelector: '#whiteboard-highlighting-warning',
					allowedHighlightingTabs: new Set(['content', 'stepreads'])
				},
				splitTabData: {
					tabKey: 'articleTab',
					defaultTab: 'content',
					eventName: WHITEBOARD_TOOL_CLICK
				},
				decodablePrintOptions: [
					{
						name: 'decodable',
						label: 'Decodable'
					},
					{
						name: 'teacher-edition',
						label: 'Teacher Edition'
					},
					{
						name: 'both',
						label: 'Both'
					}
				],
				printDecodables: {
					all: false,
					section: 'decodable'
				},
				printTextSets: {
					questionSets: true,
					fullOrExpress: 'f',
					passages: 'all',
					selectedPassages: []
				},
				contentTabs: [],
				splitTabs: undefined,
				unsubAssignmentEnd: undefined
			};
		},
		methods: {
			tabAuthenticationCheck: function () {
				let userContext = this.userContext;
				let articleTab = this.articleTab;

				if (!userContext || userContext.classCode) {
					let tabs = this.tabs;
					let tab = null;
					tabs.every(t => {
						if (t.component && t.component === articleTab) {
							tab = t;
							return false;
						}
						return true;
					});
					if (tab && tab.authRequired) {
						model.set('articleTab', 'content');
					}
				}
			},
			toggleOnList: function (article) {
				if (!this.binder) {
					return undefined;
				}
				let productId = article.uuid;
				let inBinder = this.binder.some(l => l.productId === productId);
				const origin = this.articleEntryPoint;

				if (inBinder) {
					fireEvent(REMOVE_FROM_BINDER, {
						p: productId,
						origin
					});

					return crudService.remove('myList', productId);
				} else {
					// if product ID contains version, strip it out and just use the UUID
					if (utilities.productIdHasVersion(productId)) {
						var pv = utilities.parseProductUUIDAndVersion(productId);
						productId = pv.uuid;
					}

					fireEvent(ADD_TO_BINDER, {
						p: productId,
						origin
					});

					return crudService.create('myList', {
						productId
					});
				}
			},
			firePrintEvent(options = []) {
				let contentKey = 'content_';
				let product = this.article;
				let pid = product.uuid;
				let printMode = this.printMode;
				let lines = this.lines;
				let boost = undefined;
				let challenge = undefined;
				const origin = this.articleEntryPoint;

				options = utilities.cloneDeep(options || this.printOptions);

				if (lines === 'true') {
					options.push('lines');
				}

				// Check iF all articles are being printed
				// and add 'content_all' for the event
				if (product.articleList && product.articleList.length) {
					let content = options.filter(o => {
						return typeof o === 'string' && o.substr(0, contentKey.length) === contentKey;
					});

					if (content.length && ['AAD', 'TS'].includes(product.productType) && printMode === 'packet') {
						// content_all when packet selected
						options.push('content_all');
						if (this.challenge) {
							challenge = true;
						}
						if (this.support) {
							boost = true;
						}
					} else if (content.length === product.articleList.length && ['P', 'TS'].includes(product.productType)) {
						// Paired Text and Text Set content_all when all articles are selected
						options.push('content_all');
					} else if (content.length === 1 && product && product.supplemental_texts) {
						let singleArticlePid = content[0].replace(contentKey, '');
						if (product.supplemental_texts.challenge && product.supplemental_texts.challenge[singleArticlePid]) {
							challenge = true;
						} else if (product.supplemental_texts.support && product.supplemental_texts.support[singleArticlePid]) {
							boost = true;
						}
					}
				}

				let printInfo = {
					pid,
					options,
					boost,
					challenge,
					origin
				};

				fireEvent(PRINT, printInfo);
			},
			openPrintModal: function () {
				let pid = this.article.uuid;
				let articleTab = this.articleTab;

				fireEvent(OPEN_PRINT_MODAL, {
					pid,
					articleTab
				});
				this.support = false;
				this.challenge = false;
				this.printDecodables = {
					all: false,
					section: 'decodable'
				};
				this.lines = 'false';
				if (this.article.productType === 'AAD') {
					utilities.openModal('#aad-print-modal');
				} else {
					utilities.openModal('#print-options-modal');
				}
			},
			openAssignModal: function () {
				const { uuid: pid, productType } = this.article;
				const articleTab = this.articleTab;

				fireEvent(OPEN_ASSIGN_MODAL, {
					pid,
					articleTab
				});

				if (productType === 'TS') {
					utilities.openModal('#assignment-wizard');
				} else {
					utilities.openModal('#modal-assign');
				}
			},
			printAAD: function () {
				const printOptions = this.printOptions.filter(option => !(option.includes('content_') || option.includes('decodables_')));
				const article = this.article;

				let supplemental = [];
				if (this.printMode === 'single') {
					const selectedArticle = this.selectedArticle;
					const uuid = selectedArticle.uuid;

					if (selectedArticle.decodableTeacherEdition) {
						const section = this.printDecodables.section;
						const printDecodable = ['decodable', 'both'].includes(section);
						const printTeacherEdition = ['teacher-edition', 'both'].includes(section);

						if (printDecodable) {
							supplemental.push(`decodables_${model.get('decodablesSection')}_${uuid}`);
						}

						if (printTeacherEdition) {
							supplemental.push(`decodables_${model.get('decodablesSection')}_${uuid}_teacher-edition`);
						}
					} else {
						supplemental = [`content_${uuid}`];
					}
				} else {
					const uuidMapFn = ({ uuid }) => `content_${uuid}`;

					// Populate print options with all articles.
					supplemental = this.article.articleList.map(uuidMapFn);

					if (this.challenge && this.challengeArticles) {
						supplemental = supplemental.concat(this.challengeArticles.map(uuidMapFn));
					}
					if (this.support && this.supportArticles) {
						supplemental = supplemental.concat(this.supportArticles.map(uuidMapFn));
					}
					if (article.dteGroups && this.printDecodables.all) {
						const decodableArticles = article.dteGroups.reduce((acc, group) => {
							return [...acc, ...Object.keys(group.articles).map(uuid => `decodables_${group.id}_${uuid}`)];
						}, []);

						supplemental = supplemental.concat(decodableArticles);
					}
				}

				this.printOptions = supplemental.concat(printOptions);
				this.print();
			},
			getTextSetPrintOptions(printOptions) {
				const options = new Set(printOptions);
				const printVocab = options.has('printvocabulary');
				const printVocabActivities = options.has('vocab-activities');
				const { questionSets, fullOrExpress, selectedPassages } = this.printTextSets;
				const article = this.article;
				const articleList = article.articleList;
				const selectedPassagesSet = new Set(selectedPassages);
				const printAll = this.printMode === 'packet';

				return articleList.reduce((acc, subArticle) => {
					const uuid = subArticle.uuid;
					if (printAll || selectedPassagesSet.has(subArticle.uuid)) {
						acc.push(`content_${uuid}`);

						if (subArticle.vocab) {
							if (printVocab) {
								acc.push('printvocabulary');
							}

							if (printVocabActivities && subArticle.vocab.activity) {
								acc.push('vocab-activities');
							}
						}

						if (questionSets && subArticle.questionSets) {
							const qset = subArticle.questionSetsOrdered[0];
							acc.push(`questionsets_${qset.qsid}`);

							this.fullOrExpress[qset.qsid] = qset.abridged_question_ids && qset.abridged_question_ids.length > 0 ? fullOrExpress : 'f';
						}
					}

					return acc;
				}, []);
			},
			print: function () {
				var printOptions = utilities.cloneDeep(this.printOptions);
				const year = new Date().getFullYear();
				const isTextSet = this.article.productType === 'TS';

				utilities.openModal('#printing-modal');

				var originalSelections = {
						articleTab: model.get('articleTab'),
						stepreadsSection: model.get('stepreadsSection'),
						contentSection: model.get('contentSection'),
						questionsetsSection: model.get('questionsetsSection'),
						answerKey: model.get('answerKey')
					},
					serializer = new Serializer(),
					pdfs = [],
					self = this;

				self.isPrinting = true;

				var printOptionsOrdered = [];
				let excludeImages = false;

				this.printOrdering.forEach(function (tabOrder) {
					printOptions.forEach(function (option) {
						if (option === 'exclude-images') {
							excludeImages = true;
						} else if (option.indexOf(tabOrder) === 0) {
							printOptionsOrdered.push(option);
						}
					});
				});

				if (isTextSet) {
					printOptionsOrdered = this.getTextSetPrintOptions(printOptions);
				}

				var isFullAADPacket =
					self.article.productType === 'AAD' &&
					_.filter(printOptions, function (value) {
						return value.indexOf('content_') !== -1;
					}).length > 1;

				if (isFullAADPacket) {
					serializer.queue(function () {
						return Q.ninvoke(Vue, 'nextTick').then(function () {
							return generatePDFForSection('#aad-toc', {
								footer:
									'<div style="font-size:10px;text-align:right"><div>© ' +
									year +
									'ReadWorks®, Inc. All rights reserved.</div>' +
									(self.article.cid != 414 && metadataUtils.getPartner(self.article.cid)
										? '<div>Articles generously provided by ' + self.article.collectionName + ' are included. All rights reserved. Used by permission.</div>'
										: '') +
									'</div>',
								extended_font: self.usePDFExtendedFont
							}).then(function (pdf) {
								pdfs.push(pdf);
							});
						});
					});
				}

				printOptionsOrdered.forEach(function (option) {
					var optionTokens = option.split('_'),
						section = optionTokens[0],
						id = optionTokens[1];

					serializer.queue(function () {
						var tabState = {
							articleTab: section,
							printing: true
						};
						let stepread = null;

						if (id) {
							tabState[section + 'Section'] = id;

							if (section === 'questionsets') {
								// Answer key toggle
								tabState.answerKey = optionTokens[2] === 'answerkey';
							} else if (section === 'stepreads') {
								let stepreadsIndex = parseInt(id);
								stepread = self.article.articleList[stepreadsIndex - 1];
								tabState.stepreadsSection = stepread.uuid;
							} else if (section === 'decodables') {
								tabState.decodablesArticle = optionTokens[2];
							}
						}

						model.set(tabState);

						return Vue.nextTick().then(() => {
							var grades = self.article.grades || self.article.articles[Object.keys(self.article.articles)[0]].grades,
								isKOr1 = grades && (grades.indexOf(16) !== -1 || grades.indexOf(17) !== -1),
								is2 = grades && grades.indexOf(18) !== -1,
								is3Or4Or5 = grades && (grades.indexOf(19) !== -1 || grades.indexOf(20) !== -1 || grades.indexOf(21) !== -1),
								target,
								header;

							switch (section) {
								case 'content':
								case 'video':
								case 'stepreads':
								case 'decodables':
									var footer = '',
										documentHeader = '<div style="text-align:center" class="rte"><div style="font-weight:bold;font-size:1.75rem;margin-bottom:0.5rem">',
										article = self.article;

									target = 'article';

									if (section === 'video') {
										target = '.video-content';
									}

									if (['P', 'AAD', 'TS'].includes(article.productType)) {
										article = self.selectedArticle;
									}

									documentHeader += article.title + '</div>';

									if (article.authors && article.authors.length) {
										let adaptedBy = [];

										if (self.articleTab === 'stepreads') {
											if (stepread && Array.isArray(stepread.authors) && !_.isEqual(article.authors, stepread.authors)) {
												adaptedBy = stepread.authors;
											}
										}

										documentHeader += '<div>by ' + article.authors.join(', ');
										documentHeader += (adaptedBy.length > 0 ? ' (Adapted by ' + adaptedBy.join(', ') + ')' : '') + '</div>';
									}

									documentHeader += '</div>';

									if (article.cid == 414) {
										footer = '<div style="font-size:10px">ReadWorks.org · ' + stringUtilities.stripHTML(article.copyright) + '</div>';
									} else {
										var partner = metadataUtils.getPartner(article.cid);

										if (partner) {
											footer = '<img style="height:20px;float:left" src="' + partner.imgUrl + '">';
										}

										if (article.copyright) {
											footer +=
												'<div>ReadWorks.org</div><div ' +
												(isFullAADPacket ? 'style="width:25rem;float:right"' : '') +
												'>' +
												stringUtilities.stripHTML(article.copyright) +
												'</div>';
										} else {
											footer += '<div>ReadWorks.org</div>';
										}

										footer = '<div style="text-align:right;font-size:10px;">' + footer + '</div>';
									}

									var cssClasses = null;

									if (isKOr1) {
										cssClasses = ['print-font-large', 'print-line-height-large'];
									} else if (is2) {
										cssClasses = ['print-font-marge', 'print-line-height-large'];
									} else if (is3Or4Or5) {
										cssClasses = ['print-font-medium', 'print-line-height-large'];
									} else {
										cssClasses = ['print-line-height-medium'];
									}

									header = article.title;

									if (section === 'decodables') {
										cssClasses = ['print-font-xlarge', 'print-line-height-xlarge'];
										if (optionTokens[3] === 'teacher-edition') {
											excludeImages = true;
											target = 'article, .article-aside';
											cssClasses = ['print-line-height-medium'];
											header += ' Teacher Edition';
										}
									}

									if (self.articleTab === 'stepreads') {
										header += ' - ' + $('#content nav .active').html();
									}

									if (header.length > 100) {
										var tokens = header.split(' ');

										header = '<div>' + tokens.slice(0, 10).join(' ') + '</div><div>' + tokens.slice(10).join(' ') + '</div>';
									}

									return generatePDFForSection(target, {
										header: header,
										footer: footer,
										documentHeader: article.subType === 102 ? void 0 : documentHeader,
										cssClasses: cssClasses,
										extended_font: self.usePDFExtendedFont,
										excludeImages
									}).then(function (pdf) {
										pdfs.push(pdf);
									});
								case 'questionsets':
									const isAnswerKey = $('.show-answer').length !== 0;
									article = self.article.productType === 'TS' ? self.selectedArticle : self.article;
									const filename = article.title + ' - ' + article.questionSets[id].title + (isAnswerKey ? ' Answer Key' : '');

									target = '.question-set';
									header = '';

									if (article.productType !== 'P') {
										header += filename;
									} else {
										var ptArticlesTitles = [];

										for (var key in self.article.articles) {
											ptArticlesTitles.push(self.article.articles[key].title);
										}

										header += '<div>' + filename + '</div><div>' + ptArticlesTitles.join(' · ') + '</div>';
									}

									$('.directions').css('margin-top', '50px');

									if (isKOr1) {
										$(target).css('font-size', '150%');
									}

									cssClasses = null;

									if (self.lines === 'true' && !tabState.answerKey) {
										cssClasses = ['show-written-answer-lines'];
									}

									return generatePDFForSection(target, {
										header: header,
										footer: `<div style="font-size:10px;text-align:right"><div>ReadWorks.org · © ${year} ReadWorks®, Inc. All rights reserved.</div></div>`,
										documentHeader: isAnswerKey ? '' : '<strong>Name: ___________________________________ Date: _______________</strong>',
										cssClasses: cssClasses,
										extended_font: self.usePDFExtendedFont,
										excludeImages
									}).then(function (pdf) {
										pdfs.push(pdf);

										$('.directions').css('margin-top', '');

										if (isKOr1) {
											$(target).css('font-size', '');
										}
									});
								case 'printvocabulary':
									// PDF.js sets the image to width:0 height:0 if we don't have an explicit size
									// on it. Other images seem to work fine, I cannot figure out what's different
									// about vocab-entry's image. So setting explicit sizing
									$('.printvocabulary img.vocab-entry-image').each((idx, img) => {
										var width = $(img).width(),
											height = $(img).height();
										$(img).css({ width: '' + width + 'px', height: '' + height + 'px' });
									});
									return generatePDFForSection('.printvocabulary', {
										header: 'ReadWorks Vocabulary',
										footer: `<div style="font-size:10px;text-align: right;"><div>ReadWorks.org · © ${year} ReadWorks®, Inc. All rights reserved.</div><div>Definitions and sample sentences within definitions are provided by Wordsmyth. © ${year} Wordsmyth. All rights reserved.</div></div>`,
										documentHeader: '<div style="font-size:1.5rem; margin-bottom: 1.5rem;"><strong class="pushover">Vocabulary</strong></div>',
										extended_font: self.usePDFExtendedFont,
										excludeImages
									}).then(function (pdf) {
										pdfs.push(pdf);
									});
								case 'word-detective-preview':
									return generatePDFForSection('.word-detective-print', {
										header: '<strong>Name: __________________________________  Date: _______________</strong> &nbsp;',
										footer: `<div style="font-size:10px;"><div>ReadWorks.org · © ${year} ReadWorks®, Inc. All rights reserved.</div>`,
										extended_font: self.usePDFExtendedFont
									}).then(function (pdf) {
										pdfs.push(pdf);
									});
								case 'meaning-mapper-preview':
									return generatePDFForSection('.meaning-mapper-print', {
										header: '<strong>Name: __________________________________  Date: _______________</strong> &nbsp;',
										footer: `<div style="font-size:10px;"><div>ReadWorks.org · © ${year} ReadWorks®, Inc. All rights reserved.</div>`,
										extended_font: self.usePDFExtendedFont,
										excludeImages
									}).then(function (pdf) {
										pdfs.push(pdf);
									});
								case 'vocab-activities':
									return generatePDFForSection('.vocab-activity-tab', {
										header: '<strong>Name: __________________________________  Date: _______________</strong> &nbsp;',
										footer: `<div style="font-size:10px;"><div>ReadWorks.org · © ${year} ReadWorks®, Inc. All rights reserved.</div><div>Vocabulary powered by WordSmyth. © ${year} Wordsmyth. All rights reserved.</div></div>`,
										extended_font: self.usePDFExtendedFont,
										excludeImages
									}).then(function (pdf) {
										pdfs.push(pdf);
									});
							}
							return undefined;
						});
					});
				});

				hashStore.forceReplaceState = true;

				let pdfWindow = window.open('/printing-article', '_blank');

				serializer
					.execute()
					.then(function () {
						const blob = PDF.concat(pdfs, {
							pageNumbers: isFullAADPacket
						});
						const blobUrl = URL.createObjectURL(blob);

						pdfWindow.location.href = blobUrl;
					})
					.catch(function (error) {
						logger.error(error);

						if (pdfWindow) {
							pdfWindow.close();
						}
					})
					.fin(function () {
						self.resetFullOrExpress();
						self.isPrinting = false;

						for (var key in originalSelections) {
							if (typeof originalSelections[key] !== 'undefined') {
								model.set(key, originalSelections[key]);
							}
						}
						model.remove('printing');

						hashStore.forceReplaceState = false;

						utilities.closeModals();

						if (!window.adsByGoogleLoaded || !window.showAdsLoaded) {
							utilities.openModal('#ad-blocker-modal');
						}

						self.updatePPAMilestone();
					});

				const printEventOptions = isTextSet ? [...new Set([...printOptions, ...printOptionsOrdered])] : printOptions;

				this.firePrintEvent(printEventOptions);
			},
			forceLogin: function () {
				utilities.openModal('#teacher-login-modal');
			},
			goBackToSearchResults: function () {
				page('/find-content' + this.searchResults);
			},
			goBackToReadingList: function () {
				page('/promotional-collection#!promoId:' + this.promoLink);
			},
			goBackToScopeAndSequence: function () {
				page('/find-content#!contentTab:scope-and-sequence');
			},
			getMyList: function () {
				if (this.userContext) {
					crudService.read('myList').then(list => (this.binder = list));
				}
			},
			fireCopyEvent() {
				let product = this.article;
				let pid = product.uuid;
				fireEvent(PRODUCT_PREVIEW_COPY, {
					pid
				});
			},
			buildSearchResultsMap(searchResults = this.searchResults) {
				if (typeof searchResults !== 'string') return;

				const searchResultsDict = hashStore.deserialize(searchResults);
				this.searchResultsMap = new Map(Object.entries(searchResultsDict));
			},
			initFromSearchResults() {
				this.initFullOrExpress();
			},
			initFullOrExpress() {
				if (this.orderedQuestionSetsMinusVocab.length === 0) return;
				const searchResultsMap = this.searchResultsMap || new Map();

				const activityType = searchResultsMap.get('at') || '';
				const atHasExpress = activityType.includes('express');
				const atHasFull = activityType.includes('full');
				const canShowExpress = atHasExpress && !atHasFull;

				const fullOrExpress = this.orderedQuestionSetsMinusVocab.reduce(
					(acc, { qsid, abridged_question_ids: abridged }) => {
						acc[qsid] = abridged && abridged.length > 0 && canShowExpress ? 'x' : 'f';
						return acc;
					},
					Object.assign({}, this.fullOrExpress)
				);

				this.setFullOrExpress(fullOrExpress);
			},
			setFullOrExpress(fullOrExpress) {
				this.userFullOrExpress = Object.assign({}, fullOrExpress);
				this.fullOrExpress = Object.assign({}, fullOrExpress);
			},
			resetFullOrExpress() {
				this.fullOrExpress = Object.assign({}, this.userFullOrExpress);
			},
			onPrintVocabChange(event) {
				const printVocab = event.target.checked;
				const printVocabActivities = 'vocab-activities';
				let printOptions = this.printOptions.filter(option => option !== printVocabActivities);

				if (printVocab) {
					printOptions.push(printVocabActivities);
				}

				this.printOptions = printOptions;
			},
			getArticleSubtitle(context) {
				const article = this.article;

				if (!article) {
					return '';
				}

				const { productType, hasVideo, subType } = article;
				const isModal = context === 'modal';

				if (productType === 'P') {
					if (hasVideo) {
						return 'Paired Video';
					}
					if (subType === 8001) {
						return 'Spanish-English Paired Text';
					}
					return 'Paired Text';
				}

				if (productType === 'AAD') {
					const suffix = isModal ? ' Set' : '';
					return `Article-A-Day${suffix}`;
				}

				if (productType === 'TS' && subType === 7000) {
					const category = getBookStudyCategoryText(article.bookStudy.category);

					return isModal ? `${article.bookStudy.book.title}: ${category}` : `${category} Book Study`;
				}

				return '';
			},
			updatePPAMilestone() {
				updatePPAMilestone(this.article);
			}
		}
	};
</script>
<template>
	<div v-if="article">
		<div
			id="aad-toc"
			v-if="isPrinting && article.productType === 'AAD'">
			<img :src="printLogoSrc" />
			<div class="font-smedium">Article-A-Day™</div>
			<div class="margin-top-bottom-smedium">
				<h1 class="margin-none">{{ article.title }}</h1>
				<div>{{ aadTOCArticles.length }} Articles</div>
			</div>
			<div class="margin-bottom-medium">Check articles you have read:</div>
			<div class="toc-list">
				<div
					v-for="aad in aadTOCArticles"
					:key="aad.title"
					class="toc-item">
					<div class="box"></div>
					<div>
						<div class="toc-title">{{ aad.title }}</div>
						<div>{{ aad.wordCount }} words</div>
					</div>
				</div>
			</div>
		</div>
		<main
			id="content"
			class="main product-preview"
			:class="{
				'split-screen': splitScreen
			}"
			role="main">
			<template v-if="productNotFound !== true">
				<header class="main-header -has-nav">
					<div class="wrapper">
						<span
							v-if="searchResults"
							@click="goBackToSearchResults"
							class="main-header-back -sticky"
							>&larr; Search Results</span
						>
						<span
							v-if="promoLink"
							@click="goBackToReadingList"
							class="main-header-back -sticky"
							>&larr; Back to Reading List</span
						>
						<span
							v-if="scopeSequenceLink"
							@click="goBackToScopeAndSequence"
							class="main-header-back -sticky"
							>&larr; Back to Scope and Sequence</span
						>
						<div
							v-if="!splitScreen"
							class="main-header-title-wrapper print-centered">
							<h1 class="main-header-title">
								{{ article.title }}
							</h1>
							<div class="main-header-subtitle font-small text-muted">{{ getArticleSubtitle() }}</div>
						</div>
						<ul class="main-header-actions">
							<load-mask v-if="loading"></load-mask>
							<template v-if="whiteboardView">
								<li>
									<button
										class="whiteboard-button button -small tooltip-bottom -outline"
										v-tooltip="'Change Font Size'"
										@click="onFontSizeClick">
										<i
											class="icon-font-size"
											aria-hidden="true"></i>
									</button>
								</li>
								<li class="article-print-button-container">
									<button
										v-if="articleTab === 'content'"
										class="whiteboard-button button -small tooltip-bottom"
										:class="{
											'-outline': !paragraphsNumbered
										}"
										v-tooltip="'Add Paragraph Numbers'"
										:aria-pressed="`${paragraphsNumbered}`"
										@click="onParagraphNumbersClick">
										<i
											class="fa-solid fa-paragraph"
											aria-hidden="true"></i>
									</button>
								</li>
								<li v-if="article.productType !== 'AAD' && splitTabs.length > 0">
									<button
										v-tooltip="'Use split screen'"
										class="button -outline toolbar-button -small split-screen-button tooltip-bottom"
										:aria-pressed="`${splitScreen}`"
										@click="onSplitScreenClick"
										:class="{ '-active': splitScreen }">
										<i
											class="fa-solid fa-table-columns"
											aria-hidden="true"></i>
									</button>
								</li>
							</template>
							<li class="article-assign-button-container">
								<button
									v-if="userContext && !userContext.classCode"
									@click="openAssignModal"
									class="assign-button button -small"
									:class="{
										disabled: loading
									}"
									:disabled="loading">
									Assign
								</button>
								<button
									v-if="!userContext || userContext.classCode"
									@click="forceLogin"
									class="assign-button button -small">
									Assign
								</button>
							</li>
							<li class="article-print-button-container">
								<button
									v-if="articleTab !== 'book-of-knowledge' && userContext && !userContext.classCode"
									@click="openPrintModal"
									class="button -small"
									:class="{
										disabled: loading
									}"
									:disabled="loading">
									Print
								</button>
								<button
									v-if="articleTab !== 'book-of-knowledge' && (!userContext || userContext.classCode)"
									@click="forceLogin"
									class="button -small">
									Print
								</button>
							</li>
							<li
								v-if="article.id"
								:class="{
									'position-relative': !!gcAddon
								}">
								<button
									v-if="userContext && !userContext.classCode"
									class="whiteboard-button button -small tooltip-bottom"
									:class="{
										'-outline': whiteboardView,
										disabled: loading || gcAddon
									}"
									:disabled="loading || gcAddon"
									v-tooltip="whiteboardView ? 'Exit Whiteboard/Projector view' : 'Enter Whiteboard/Projector view'"
									@click="onWhiteboardViewClick">
									<i
										class="fa-solid"
										:class="{
											'fa-xmark': whiteboardView,
											'fa-desktop': !whiteboardView
										}"
										aria-hidden="true"></i>
								</button>
								<button
									v-else
									class="whiteboard-button button -small tooltip-bottom"
									v-tooltip="'Enter Whiteboard/Projector view'"
									@click="forceLogin">
									<i
										class="fa fa-desktop"
										aria-hidden="true"></i>
								</button>
								<classroom-addon-lock-tooltip
									v-if="gcAddon"
									help-text="Whiteboard View"></classroom-addon-lock-tooltip>
							</li>
							<li
								class="article-mylist-button-container"
								:class="{
									'position-relative': !!gcAddon
								}">
								<add-to-my-list-button
									:toggle-on-list="toggleOnList"
									:article="article"
									:my-list="binder"
									:logged-in="!!userContext && !userContext.classCode"
									:disabled="loading || gcAddon"
									button-style>
								</add-to-my-list-button>
								<classroom-addon-lock-tooltip
									v-if="gcAddon"
									help-text="Save to My List"></classroom-addon-lock-tooltip>
							</li>
						</ul>
						<tab-container
							class="print-hidden"
							:tabs="tabs"
							default-tab="content"
							model-key="articleTab">
							<template v-if="!splitScreen && !loadingClass">
								<template v-for="tab in tabs">
									<button
										v-if="((userContext && !userContext.classCode) || !tab.authRequired) && tab.component !== 'stepreads'"
										:data-tab="tab.component">
										{{ tab.label }}
									</button>
									<div
										class="stepread-tab"
										v-if="((userContext && !userContext.classCode) || !tab.authRequired) && tab.component === 'stepreads'">
										<button :data-tab="tab.component">
											{{ tab.label }}
										</button>
										<button
											class="button -link"
											v-tooltip="
												'StepReads™ are less complex versions of the original article. StepRead1 (SR1) is less complex than the original article, and StepRead2 (SR2) is less complex than SR1. <a href=\'/teacher-guide/differentiation-content.html#stepreads\'> Learn more...</a>'
											">
											<sup
												style="margin-left: -0.25rem"
												class="font-normal">
												<info-icon></info-icon>
											</sup>
										</button>
									</div>
									<button
										v-if="(!userContext || userContext.classCode) && tab.authRequired"
										@click="forceLogin">
										{{ tab.label }}
									</button>
								</template>
							</template>
						</tab-container>
					</div>
				</header>
				<div
					class="article-single wrapper"
					:class="[
						fontSizeClass,
						{
							'split-screen-content': splitScreen
						}
					]"
					@copy="fireCopyEvent"
					@cut="fireCopyEvent"
					ref="articleTabPanel"
					:data-panel="articleTab">
					<template v-if="splitScreen">
						<tab-panel
							:tabs="contentTabs"
							:tab-key="'articleTab'"
							:enable-snap-to-top="!splitScreen"
							ref="rightTabs"
							class="content-panel">
							<div slot="tab-panel-body">
								<h1
									v-if="article.productType === 'A'"
									class="margin-bottom-small margin-top-small">
									{{ article.title }}
								</h1>
								<component
									:is="articleTabComponent"
									:route-context="routeContext"
									:article="article"
									:selected-article="selectedArticle"
									:search-results="searchResults"
									:paragraphs-numbered="paragraphsNumbered"
									:full-or-express="fullOrExpress"
									:set-full-or-express="setFullOrExpress"></component>
							</div>
						</tab-panel>
						<tab-panel
							v-if="splitTab && splitTabs.length"
							:tabs="splitTabs"
							:tab-key="'splitTab'"
							:enable-snap-to-top="!splitScreen"
							ref="rightTabs"
							class="split-panel">
							<component
								slot="tab-panel-body"
								:is="splitTab"
								:route-context="routeContext"
								:article="article"
								:selected-article="selectedArticle"
								:search-results="searchResults"
								:paragraphs-numbered="paragraphsNumbered"
								:full-or-express="fullOrExpress"
								:set-full-or-express="setFullOrExpress"></component>
						</tab-panel>
					</template>
					<component
						v-if="!splitScreen"
						:show-aside="!(isPrinting && printDecodables.section === 'decodable')"
						:is="articleTabComponent"
						:route-context="routeContext"
						:article="article"
						:selected-article="selectedArticle"
						:search-results="searchResults"
						:paragraphs-numbered="paragraphsNumbered"
						:full-or-express="fullOrExpress"
						:set-full-or-express="setFullOrExpress"></component>
				</div>
			</template>
			<template v-if="productNotFound === true">
				<header class="main-header">
					<div class="wrapper">
						<h1 class="main-header-title">Whoops!</h1>
					</div>
				</header>
				<div class="main-content wrapper rte">
					<p>This product is currently unavailable on the site. But you can find other great content <a href="/find-content">here</a>!</p>
				</div>
			</template>
			<a
				v-if="article.productType === 'AAD'"
				ref="edgePdfDownload"
				:href="mediaUrl + '/data/pdf/' + article.uuid + '.pdf'"
				:download="`${article.title}.pdf`"></a>
		</main>
		<assignment-wizard
			v-if="article.productType === 'TS'"
			title="Assign"
			:subtitle="article.title"
			:category-text="getArticleSubtitle('modal')"
			:defaults="assignmentWizardOptions"
			:has-vocab-activity="hasVocabActivity"
			:has-question-sets="orderedQuestionSetsMinusVocab.length > 0"
			:has-express-question-sets="hasExpressQuestionSets"
			:text-set="{
				subType: article.subType,
				pid: article.uuid,
				category: article.bookStudy && article.bookStudy.category,
				book: article.bookStudy && article.bookStudy.book.id,
				title: article.title
			}"
			flexible-dates></assignment-wizard>
		<assignment-modal
			v-else-if="article.id"
			show-article-title
			:product-id="article.id"
			:full-or-express="fullOrExpress"></assignment-modal>
		<modal id="aad-print-modal">
			<template slot="header-container">
				<h2>Print</h2>
				<h3>{{ article.title }}</h3>
				<div class="font-small text-muted">Article-A-Day Set</div>
			</template>
			<template slot="content">
				<form>
					<div>
						<label>
							<input
								type="radio"
								value="packet"
								v-model="printMode" />
							All articles in this set
						</label>
					</div>
					<div
						class="margin-left-smedium"
						v-if="article.supplemental_texts && article.supplemental_texts.support">
						<label
							:class="{
								disabled: printMode !== 'packet'
							}">
							<input
								type="checkbox"
								:disabled="printMode !== 'packet'"
								value="support"
								v-model="support" />
							Include Boost Articles
						</label>
					</div>
					<div
						class="margin-left-smedium"
						v-if="article.supplemental_texts && article.supplemental_texts.challenge">
						<label
							:class="{
								disabled: printMode !== 'packet'
							}">
							<input
								type="checkbox"
								:disabled="printMode !== 'packet'"
								value="challenge"
								v-model="challenge" />
							Include Challenge Articles
						</label>
					</div>
					<div
						class="margin-left-smedium"
						v-if="article.dteGroups">
						<label
							:class="{
								disabled: printMode !== 'packet'
							}">
							<input
								type="checkbox"
								name="decodables"
								value="decodables"
								:disabled="printMode !== 'packet'"
								v-model="printDecodables.all" />
							Include Decodables
						</label>
					</div>
					<div v-if="selectedArticle">
						<label>
							<input
								type="radio"
								value="single"
								v-model="printMode" />
							Only this article: {{ selectedArticle.title }}
						</label>
						<div
							v-if="selectedArticle.decodableTeacherEdition"
							class="inline-print-fields">
							<label
								v-for="decodablePrintOption in decodablePrintOptions"
								:key="decodablePrintOption.name"
								:class="{
									disabled: printMode === 'packet'
								}">
								<input
									type="radio"
									name="decodable-print-options"
									:value="decodablePrintOption.name"
									:disabled="printMode === 'packet'"
									v-model="printDecodables.section" />
								{{ decodablePrintOption.label }}
							</label>
						</div>
					</div>
					<hr v-if="article.word_detective || article.meaning_mapper" />
					<label v-if="article.word_detective">
						<input
							type="checkbox"
							value="word-detective-preview"
							v-model="printOptions" />
						Word Detective Graphic Organizer
					</label>
					<label v-if="article.meaning_mapper">
						<input
							type="checkbox"
							value="meaning-mapper-preview"
							v-model="printOptions" />
						Meaning Mapper Graphic Organizer
					</label>
					<hr />
					<div class="label">
						<label>
							<input
								type="checkbox"
								v-model="printOptions"
								name="exclude-images"
								value="exclude-images" />Exclude Images
						</label>
						<button
							type="button"
							class="button -link"
							v-tooltip="
								'Save ink and paper by omitting images from this print-out. Please ensure that images are not critical for the comprehension of this content.'
							">
							<info-icon></info-icon>
						</button>
					</div>
				</form>
				<button
					class="button -centered"
					v-on:click="printAAD">
					Print
				</button>
			</template>
		</modal>
		<modal id="print-options-modal">
			<template slot="header-container">
				<h2>Print</h2>
				<h3>{{ article.title }}</h3>
				<div
					v-if="getArticleSubtitle('modal')"
					class="font-small text-muted">
					{{ getArticleSubtitle('modal') }}
				</div>
			</template>
			<template slot="content">
				<form>
					<div v-if="article.productType === 'A'">
						<label>
							<input
								type="checkbox"
								value="content"
								v-model="printOptions" />
							Reading Passage
						</label>
						<label v-if="article.hasVideo">
							<input
								type="checkbox"
								value="video"
								v-model="printOptions" />
							Video Text
						</label>
						<div
							class="margin-left-smedium"
							v-if="article.sr">
							<div
								v-for="(stepread, srIndex) in article.articleList"
								:key="srIndex">
								<label>
									<input
										type="checkbox"
										:value="`stepreads_${srIndex + 1}`"
										v-model="printOptions" />
									StepRead{{ srIndex + 1 }} (SR{{ srIndex + 1 }})</label
								>
							</div>
						</div>
					</div>
					<div v-if="article.productType === 'P'">
						<div
							v-for="subArticle in article.articles"
							:key="subArticle.uuid">
							<label>
								<input
									type="checkbox"
									:value="'content_' + subArticle.uuid"
									v-model="printOptions" />
								{{ subArticle.title + (subArticle.video ? ' Text' : '') }}
							</label>
						</div>
					</div>
					<div v-if="hasVocabActivity">
						<label>
							<input
								type="checkbox"
								value="printvocabulary"
								v-model="printOptions"
								@change="onPrintVocabChange" />
							Vocabulary
						</label>
						<div class="margin-left-smedium margin-top-small">
							<label>
								<input
									type="checkbox"
									value="vocab-activities"
									v-model="printOptions" />
								Vocabulary Activities
							</label>
						</div>
					</div>
					<template v-if="orderedQuestionSetsMinusVocab">
						<div v-if="article.productType === 'TS'">
							<label>
								<input
									type="checkbox"
									v-model="printTextSets.questionSets" />
								Comprehension Questions
							</label>
							<div
								v-if="hasExpressQuestionSets"
								class="inline-print-fields">
								<label>
									<input
										type="radio"
										name="question-set-print-options"
										value="f"
										v-model="printTextSets.fullOrExpress" />
									Full
								</label>
								<label>
									<input
										type="radio"
										name="question-set-print-options"
										value="x"
										v-model="printTextSets.fullOrExpress" />
									Express
								</label>
							</div>
						</div>
						<div
							v-else
							v-for="(qset, qsetIndex) in orderedQuestionSetsMinusVocab"
							:key="qset.qsid">
							<label>
								<input
									type="checkbox"
									:value="'questionsets_' + qset.qsid"
									v-model="printOptions" />
								{{ qset.title }}
							</label>
							<div
								v-if="qset.abridged_question_ids && qset.abridged_question_ids.length > 0"
								class="inline-print-fields">
								<label>
									<input
										type="radio"
										name="question-set-print-options"
										value="f"
										v-model="fullOrExpress[qset.qsid]" />
									Full
								</label>
								<label>
									<input
										type="radio"
										name="question-set-print-options"
										value="x"
										v-model="fullOrExpress[qset.qsid]" />
									Express
								</label>
							</div>
						</div>
						<div class="text-muted">
							<template v-if="orderedQuestionSetsMinusVocab.length > 1">For all question sets:</template>
							<template v-else>For the question set:</template>
						</div>
						<div class="margin-left-smedium margin-top-small">
							<label>
								<input
									type="radio"
									v-model="lines"
									value="false" />without written answer lines
							</label>
							<label>
								<input
									type="radio"
									v-model="lines"
									value="true" />with written answer lines
							</label>
						</div>
					</template>
					<div class="label">
						<label>
							<input
								type="checkbox"
								v-model="printOptions"
								name="exclude-images"
								value="exclude-images" />Exclude Images
						</label>
						<button
							type="button"
							class="button -link"
							v-tooltip="
								'Save ink and paper by omitting images from this print-out. Please ensure that images are not critical for the comprehension of this content.'
							">
							<info-icon></info-icon>
						</button>
					</div>
					<template v-if="article.productType === 'TS'">
						<hr />
						<fieldset class="margin-top-small">
							<label>
								<input
									type="radio"
									v-model="printMode"
									value="packet" />
								All Passages in this Book Study
							</label>
							<label>
								<input
									type="radio"
									v-model="printMode"
									value="selection" />
								Only Some Passages
							</label>
						</fieldset>
						<div
							v-if="printMode === 'selection'"
							class="print-passage-list scroll-box">
							<label
								v-for="subArticle in article.articleList"
								:key="subArticle.uuid">
								<input
									type="checkbox"
									v-model="printTextSets.selectedPassages"
									:value="subArticle.uuid" />
								{{ subArticle.title }}
							</label>
						</div>
					</template>
				</form>
				<button
					class="button -centered margin-top-small"
					:disabled="article.productType !== 'TS' && printOptions && printOptions.length === 0"
					v-on:click="print">
					Print
				</button>
			</template>
		</modal>
		<modal
			id="ad-blocker-modal"
			:ok="true">
			<div slot="header-container">
				<h2>Print</h2>
				<h3>{{ article.title }}</h3>
			</div>
			<div slot="content">
				<p>We noticed that you have a pop-up blocker or ad blocker installed on your browser. This may be stopping the print version from appearing.</p>
				<p>Please try another browser, or update the settings on the pop-up/ad blocker to allow ReadWorks.org and try again.</p>
				<p>You may need to refresh your browser after changing the settings.</p>
			</div>
		</modal>
		<modal
			id="whiteboard-highlighting-warning"
			:closeable="false"
			:no-auto-close="true">
			<div slot="content">
				<p v-if="article.productType !== 'AAD'">Any highlights and annotations you create will not be saved.</p>
				<template v-if="article.productType === 'AAD'">
					<p>Any highlights you create will not be saved.</p>
					<p>
						Only one color is available for highlighting in Article-A-Day sets to help students focus on marking the background knowledge and vocabulary
						they have learned, the goal of the Article-A-Day routine.
					</p>
				</template>
				<div class="text-centered margin-top-large">
					<button
						class="button"
						@click="onCloseWhiteboardModalClick">
						Acknowledge
					</button>
					<div
						class="font-small link text-muted margin-top-medium"
						@click="onWhiteboardHighlightDismiss">
						Don't show this message again.
					</div>
				</div>
			</div>
		</modal>
	</div>
</template>
<style lang="scss">
	@import 'config/colors';
	@import 'config/variables';

	.product-preview {
		#aad-print-modal label {
			cursor: pointer;

			.disabled {
				opacity: 0.4;
			}
		}

		#aad-print-modal input {
			margin-right: 0.25rem;
		}

		.main-header {
			position: sticky;
			top: 0;
			z-index: 99;

			.wrapper {
				position: relative;

				.main-header-title-wrapper {
					float: left;
					clear: left;
				}

				.main-header-title {
					float: none;
				}

				.main-header-subtitle {
					display: block;
					line-height: 1;
					font-weight: 500;
				}

				.main-header-actions {
					position: relative;
					bottom: auto;
					right: auto;
					padding: 0.5rem 0;

					li:not(:first-of-type) {
						margin-left: 0.75rem;
					}

					.article-mylist-button-container button.button {
						font-size: 0.875rem;

						svg {
							height: 0.875rem;
							stroke-width: 2px;
						}
					}

					.loading-container .loading-plaque {
						background-color: transparent;
					}
				}

				.main-header-back {
					cursor: pointer;
				}
			}
		}

		.stepread-tab {
			margin-right: 1rem;
			display: inline-block;

			button {
				margin-right: 0;

				&.-link {
					border-bottom: none;
				}
			}
		}

		.split-screen-button {
			display: none;
		}
	}

	.whiteboard-view {
		.product-preview {
			.main-header {
				.main-header-title {
					font-size: 1.5rem;
					margin: 0;
				}

				.main-header-back {
					display: none;
				}

				.main-header-actions {
					padding: 0;
				}
			}

			.split-panel {
				display: none;
			}
		}
	}

	#print-options-modal,
	#aad-print-modal {
		.inline-print-fields {
			display: flex;
			padding-left: 0.5rem;

			label {
				padding: 0 1rem;
			}
		}
	}

	#aad-toc {
		.toc-list {
			display: grid;
			grid-auto-flow: column;
			grid-template-rows: repeat(10, min-content);
			gap: 2rem 1rem;
		}

		.toc-item {
			line-height: 1;
			display: flex;
		}

		.box {
			border: 1px solid #000;
			height: 2.5rem;
			width: 2.5rem;
			flex-shrink: 0;
			margin-right: 1rem;
		}

		.toc-title {
			font-size: 1.25rem;
		}
	}

	@media only screen and (min-width: $bp-width-med) {
		.product-preview {
			.main-header {
				.wrapper {
					.main-header-actions {
						li:not(:first-of-type) {
							margin-left: 1em;
						}
					}
				}
			}

			.split-screen-button {
				display: block;
			}

			.whiteboard-view & {
				.split-panel {
					display: flex;
				}
			}
		}
	}
</style>
